// extracted by css-extract-rspack-plugin
export default {"container":"_49212c39"};